import { Box, Divider, IconButton } from '@mui/material';
import ArrowSimpleRightIcon from 'assets/img/icons/ArrowSimpleRightIcon';
import { useAppSelector } from 'core/store/hooks';
import { toggleNavbar } from 'core/store/navbarSlice';
import { useDispatch } from 'react-redux';
import { CLOUD_MIST, GOLDEN_HONEY, YELLOW } from 'utils/theme';

const NavbarToggler = () => {
  const dispatch = useDispatch();
  const isNavbarExpanded = useAppSelector((state) => state.navbar.isNavbarExpanded);

  return (
    <Box display="flex">
      <Divider
        sx={{
          position: 'absolute',
          bottom: '140px',
          left: 0,
          width: '100%',
          borderColor: '#0000000D',
        }}
      />
      <IconButton
        onClick={() => dispatch(toggleNavbar())}
        sx={{
          position: 'absolute',
          bottom: '72px',
          left: isNavbarExpanded ? '172px' : '78px',
          margin: '20px',
          width: '28px',
          height: '28px',
          backgroundColor: CLOUD_MIST,
          border: `1px solid ${GOLDEN_HONEY}`,
          '&:hover': {
            border: `1px solid ${YELLOW}`,
          },
        }}
      >
        {isNavbarExpanded ? <ArrowSimpleRightIcon rotation={180} /> : <ArrowSimpleRightIcon />}
      </IconButton>
    </Box>
  );
};

export default NavbarToggler;
